<template>
  <section id="recent" class="tab-pane">
    <article
      v-for="(item, key) in getSuggestions"
      :key="item.SuggestionId"
      class="pt-3 px-3 pt-sm-3 px-sm-5"
      type="Suggestion"
      objectid="f653fe1f-1fc2-eb11-bacc-0022489cb344"
    >
      <div class="d-flex flex-nowrap">
        <img
          v-if="item.UserProfileImage"
          class="article-user-img fallback-image"
          :src="`data:image/png;base64, ${item.UserProfileImage}`"
          :alt="item.CreatedCustomerName | getInitialsFilter"
        />
        <i
          v-else
          class="article-user-img fallback-image flex-shrink-0"
          :alt="item.CreatedCustomerName | getInitialsFilter"
          >{{ item.CreatedCustomerName | getInitialsFilter }}</i
        >
        <div
          class="article-user-info flex-grow-1 pl-2 pl-sm-3 pt-sm-2 align-self-center align-self-sm-auto"
        >
          <span class="mb-1"
            >{{ item.CreatedCustomerName }} ( {{ item.CompanyName }} )</span
          >
          <span class="pt-0">{{ item.CreatedCustomerCompanyName }} şirketinden paylaşılan fikir</span>
        </div>
        <div
          class="article-further-menu dropdown ml-1 ml-sm-2 ml-md-3 ml-lg-4 show"
          v-if="user.Data.UserId === item.CreatedCustomerId"
        >
          <a
            class="btn btn-outline-light"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
            @click.stop="cardDropdownFn(item.SuggestionId)"
          >
            <svg width="15px" height="3px">
              <path
                fill-rule="evenodd"
                opacity="0.902"
                fill="rgb(53, 59, 72)"
                d="M13.333,3.000 C12.413,3.000 11.666,2.328 11.666,1.500 C11.666,0.672 12.413,-0.000 13.333,-0.000 C14.254,-0.000 15.000,0.672 15.000,1.500 C15.000,2.328 14.254,3.000 13.333,3.000 ZM7.500,3.000 C6.579,3.000 5.833,2.328 5.833,1.500 C5.833,0.672 6.579,-0.000 7.500,-0.000 C8.420,-0.000 9.166,0.672 9.166,1.500 C9.166,2.328 8.420,3.000 7.500,3.000 ZM1.666,3.000 C0.746,3.000 -0.000,2.328 -0.000,1.500 C-0.000,0.672 0.746,-0.000 1.666,-0.000 C2.587,-0.000 3.333,0.672 3.333,1.500 C3.333,2.328 2.587,3.000 1.666,3.000 Z"
              ></path>
            </svg>
          </a>
          <div
            v-if="item.SuggestionId === cardDropdownId"
            ref="carDropdown"
            class="dropdown-menu dropdown-menu-right show"
            x-placement="bottom-end"
            style="
              position: absolute;
              transform: translate3d(-121px, 36px, 0px);
              top: 0px;
              left: 0px;
              will-change: transform;
              cursor: pointer;
            "
          >
            <a class="dropdown-item" @click="deleteCardShowModal(item.SuggestionId)"
              >Sil</a
            >
            <a class="dropdown-item" @click.stop="editSuggestion(item)">Düzenle</a>
          </div>
        </div>
      </div>

      <div class="article-img clearfix"></div>

      <p class="article-content">
        {{ item.SuggestionDetail }}
      </p>

      <div
        class="article-response d-flex justify-content-end align-items-center flex-wrap"
      >
        <span>{{ item.LikeCount }} kişi beğendi</span>
        <span>{{ item.CommentCount }} yorum</span>
      </div>

      <div class="article-actions py-1">
        <span class="icon-clock" :title="item.SuggestionDate" tooltip="">{{
          item.SuggestionDate | dateDiffFilter
        }}</span>
        <button
          @click="isCommentFn(key)"
          class="btn-article-action make-comment icon-bubbles btn-toggle"
          :aria-pressed="[key !== commentId ? false : true]"
        >
          <span class="d-none d-sm-inline">Yorum Yap</span>
        </button>
        <input
          :id="item.SuggestionId"
          type="checkbox"
          class="give-heart"
          :checked="item.IsLiked"
        />
        <label
          :for="item.SuggestionId"
          class="btn-article-action btn-article-action-label"
          @click="liked(item)"
          ><i class="fas fa-heart"></i><i class="far fa-heart"></i
          ><span class="d-none d-sm-inline">Beğen</span></label
        >
      </div>

      <transition name="slide-down">
        <div v-if="key === commentId" class="article-reply">
          <img
            v-if="user.Data.UserProfileImage"
            class="comment-user-img fallback-image"
            :src="`data:image/png;base64, ${user.Data.UserProfileImage}`"
            :alt="user.Data.FullName | getInitialsFilter"
          />
          <i
            v-else
            class="comment-user-img fallback-image"
            :alt="user.Data.FullName | getInitialsFilter"
            >{{ user.Data.FullName | getInitialsFilter }}</i
          >
          <div class="icon-note">
            <textarea
              v-model="commentText"
              class="autofit"
              placeholder="Yorum Giriniz..."
            ></textarea>
          </div>
          <div v-if="commentText && commentText.length > 0" class="text-right pt-3">
            <button class="btn-reply btn-cancel" @click="commentText = ''">VAZGEÇ</button>
            <button class="btn-reply add-comment-button" @click="createComment(item)">
              YANITLA
            </button>
          </div>
        </div>
      </transition>

      <a
        v-if="item.CommentCount != 0"
        class="article-comment-show icon-down"
        @click="commentShowFn(item.SuggestionId)"
        >{{ item.CommentCount }} Yorum</a
      >
      <transition name="slide-down">
        <div
          v-if="isCommentShowId == item.SuggestionId"
          class="article-comment-container"
          style=""
        >
          <div id="commentdiv" v-for="comment in item.Comments" :key="comment.Id">
            <div
              v-show="comment.UserId == user.Data.UserId"
              class="article-further-menu dropdown show"
              style="right: 10px; margin-top: 10px; position: absolute"
            >
              <a
                class="btn btn-outline-light"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                @click.stop="commentEditFn(comment.Id)"
              >
                <svg width="15px" height="3px">
                  <path
                    fill-rule="evenodd"
                    opacity="0.902"
                    fill="rgb(53, 59, 72)"
                    d="M13.333,3.000 C12.413,3.000 11.666,2.328 11.666,1.500 C11.666,0.672 12.413,-0.000 13.333,-0.000 C14.254,-0.000 15.000,0.672 15.000,1.500 C15.000,2.328 14.254,3.000 13.333,3.000 ZM7.500,3.000 C6.579,3.000 5.833,2.328 5.833,1.500 C5.833,0.672 6.579,-0.000 7.500,-0.000 C8.420,-0.000 9.166,0.672 9.166,1.500 C9.166,2.328 8.420,3.000 7.500,3.000 ZM1.666,3.000 C0.746,3.000 -0.000,2.328 -0.000,1.500 C-0.000,0.672 0.746,-0.000 1.666,-0.000 C2.587,-0.000 3.333,0.672 3.333,1.500 C3.333,2.328 2.587,3.000 1.666,3.000 Z"
                  ></path>
                </svg>
              </a>
              <div
                ref="commentEditPoppup"
                class="dropdown-menu dropdown-menu-right"
                :style="[
                  commnetEditId == comment.Id
                    ? { display: 'block', cursor: 'pointer' }
                    : '',
                ]"
              >
                <a class="dropdown-item" @click="deleteComment(comment)">Sil</a>
                <a class="dropdown-item" @click.stop="commentEditShowModal(comment)"
                  >Düzenle</a
                >
              </div>
            </div>
            <div class="article-comment" id="article-comment-id" style="position: static">
              <div class="article-comment-body">
                <img
                  v-if="comment.UserProfileImage"
                  class="comment-user-img fallback-image"
                  :src="`data:image/png;base64, ${comment.UserProfileImage}`"
                  :alt="comment.UserName | getInitialsFilter"
                />
                <i
                  v-else
                  class="comment-user-img fallback-image"
                  :alt="comment.UserName | getInitialsFilter"
                  >{{ comment.UserName | getInitialsFilter }}</i
                >
                <span>{{ comment.UserName }} ({{ comment.UserCompanyName }})</span
                ><span class="icon-clock" :title="comment.CreatedOnUtc">
                  {{ comment.CreatedOnUtc | dateDiffFilter }}</span
                >
                <p
                  style="
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                  "
                >
                  {{ comment.CommentText }}
                </p>
              </div>
              <div class="article-comment-container" style="display: none"></div>
            </div>
          </div>
        </div>
      </transition>
    </article>
    <div
      class="load-more mt-5 mb-0"
      :class="{ 'load-more-not-cursor': getSuggestions.length >= totalRecords }"
    >
      <a
        @click="pageIndex++"
        :disabled="getSuggestions.length >= totalRecords"
        :style="[
          getSuggestions.length >= totalRecords
            ? { cursor: 'not-allowed' }
            : { cursor: 'pointer' },
        ]"
        >Daha Fazla</a
      >
    </div>
    <transition name="fade">
      <CommentEdit
        v-if="isCommentEdit"
        @close="isCommentEdit = $event"
        @edit-comment="editComment"
        :commentEditData="commentEditData"
      />
    </transition>
    <transition name="fade">
      <CardDelete
        v-if="isCardDelete"
        @close="isCardDelete = $event"
        @delete="deleteCard"
      />
    </transition>
    <transition name="fade">
      <CardEdit
        v-if="isEditCard"
        @close="isEditCard = $event"
        :editCardData="editCardData"
        :questionId="questionId"
      />
    </transition>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
  suggestionStatus,
  getInitials,
  dateDiff,
  fileTypeCheck,
} from "../../../../helpers";
import { suggestionService, upload } from "../../../../services";
import CommentEdit from "../../Cards/Modals/CommentEdit.vue";
import CardDelete from "../../Cards/Modals/CardDelete.vue";
import CardEdit from "../Modals/CardEdit.vue";
export default {
  name: "MindoNewests",
  data() {
    return {
      commentShowId: null,
      commnetEditId: null,
      commentId: null,
      pageIndex: 0,
      commentText: "",
      isCommentShowId: null,
      commentEditData: null,
      isCommentEdit: false,
      cardDropdownId: null,
      isCardDelete: false,
      cardDeleteDataId: null,
      editCardData: null,
      isEditCard: false,
    };
  },
  props: ["questionId"],
  components: {
    CommentEdit,
    CardDelete,
    CardEdit,
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      totalRecords: "mindo/suggestionTotalRecords",
    }),
    getSuggestions() {
      return this.$store.getters["mindo/getSuggestions"];
    },
  },
  filters: {
    suggestionStatusFilter(value) {
      return suggestionStatus(value);
    },
    getInitialsFilter(value) {
      return getInitials(value);
    },
    dateDiffFilter(value) {
      return dateDiff(new Date(value));
    },
  },
  watch: {
    pageIndex() {
      if (this.getSuggestions.length < this.totalRecords) {
        this.getSuggestionData();
      }
    },
    questionId() {
      this.$store.dispatch("mindo/deleteSuggestionData");
      if (this.questionId) this.getSuggestionData();
    },
  },
  beforeMount() {
    document.addEventListener("click", this.clickOutSide);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickOutSide);
  },
  methods: {
    clickOutSide(e) {
      let carDropdown = this.$refs.carDropdown ? this.$refs.carDropdown[0] : null;
      let target = e.target;
      if (carDropdown && carDropdown !== target && !carDropdown.contains(target)) {
        this.cardDropdownId = null;
      }
    },
    cardDropdownFn(item) {
      this.cardDropdownId = this.cardDropdownId === item ? null : item;
    },
    commentShowFn(item) {
      this.isCommentShowId = this.isCommentShowId === item ? null : item;
    },
    commentEditFn(item) {
      this.commnetEditId = this.commnetEditId === item ? null : item;
    },
    isCommentShowFn(item) {
      this.commentShowId = this.commentShowId === item ? null : item;
    },
    isCommentFn(item) {
      this.commentId = this.commentId === item ? null : item;
    },
    getMostLikedData() {
      const tmpData = {
        companyId: this.user.Data.CompanyId,
      };
      this.$store.dispatch("mindo/setMostLikedMindos", tmpData);
    },
    getMostCommentedData() {
      const tmpData = {
        companyId: this.user.Data.CompanyId,
      };
      this.$store.dispatch("mindo/setMostCommentedMindos", tmpData);
    },
    getSuggestionData() {
      const tmpData = {
        pageIndex: this.pageIndex,
        pageSize: 5,
        mindoQuestionId: parseInt(this.questionId),
        companyId: this.user.Data.CompanyId,
      };
      this.$store.dispatch("mindo/setSuggestionsData", tmpData);
    },
    async liked(item) {
      if (item.IsLiked) {
        //Delete Liked
        let id = null;
        item.Likes.forEach((element) => {
          if (element.UserId == this.user.Data.UserId) {
            id = element.Id;
          }
        });
        const body = {
          Id: id,
          SuggestionId: item.SuggestionId,
          UserId: this.user.Data.UserId,
        };
        const res = await suggestionService.fetchDeleteLike(body);
        if (res.Message == "like is deleted") {
          this.$store.dispatch("mindo/deleteSuggestionData");
          this.getSuggestionData();
          this.$store.dispatch("mindo/deleteMostLikedMindos");
          this.getMostLikedData();
        }
      } else {
        //Create Liked
        const body = {
          UserId: this.user.Data.UserId,
          SuggestionId: item.SuggestionId,
        };
        const res = await suggestionService.fetchCreateLike(body);

        if (res.Data) {
          this.$store.dispatch("mindo/deleteSuggestionData");
          this.getSuggestionData();
          this.$store.dispatch("mindo/deleteMostLikedMindos");
          this.getMostLikedData();
        }
      }
    },
    async createComment(item) {
      const body = {
        CommentText: this.commentText,
        SuggestionId: item.SuggestionId,
        UserId: this.user.Data.UserId,
      };
      try {
        const res = await suggestionService.fetchCreateComment(body);
        if (res.Data) {
          this.commentText = null;
          this.isCommentShowId = null;
          this.commentId = null;
          this.$toast.success("Yorumunuz başarıyla yapılmıştır.", {
            position: "top",
          });
          this.$store.dispatch("mindo/deleteSuggestionData");
          this.getSuggestionData();
          this.$store.dispatch("mindo/deleteMostCommentedMindos");
          this.getMostCommentedData();
        }
      } catch (error) {
        this.$toast.error("Yorumunuz gönderilirken bir hata oluştu.", {
          position: "top",
        });
      }
    },
    async deleteComment(item) {
      const body = {
        Id: item.Id,
        SuggestionId: item.SuggestionId,
        UserId: item.UserId,
      };
      try {
        const res = await suggestionService.fetchDeleteComment(body);
        if (res.Message == "comment is deleted") {
          this.$toast.success("Yorumunuz başarıyla silindi.", {
            position: "top",
          });
          this.$store.dispatch("mindo/deleteSuggestionData");
          this.getSuggestionData();
          this.$store.dispatch("mindo/deleteMostCommentedMindos");
          this.getMostCommentedData();
        }
      } catch (error) {
        this.$toast.error("Yorumunuz silinirken bir hata oluştu.", {
          position: "top",
        });
      }
    },
    commentEditShowModal(item) {
      this.commentEditData = item;
      this.isCommentEdit = true;
      this.commnetEditId = null;
    },
    async editComment(event) {
      const body = {
        Id: this.commentEditData.Id,
        CommentText: event,
        SuggestionId: this.commentEditData.SuggestionId,
        UserId: this.commentEditData.UserId,
      };
      try {
        const res = await suggestionService.fetchUpdateComment(body);
        if (res.Data) {
          this.$toast.success("Yorumunuz başarıyla güncellendi.", {
            position: "top",
          });
          this.$store.dispatch("mindo/deleteSuggestionData");
          this.getSuggestionData();
          this.$store.dispatch("mindo/deleteMostCommentedMindos");
          this.getMostCommentedData();
          this.isCommentEdit = false;
        }
      } catch (error) {
        this.$toast.error("Yorumunuz güncellenirken bir hata oluştu.", {
          position: "top",
        });
      }
    },
    deleteCardShowModal(item) {
      this.isCardDelete = true;
      this.cardDeleteDataId = item;
      this.cardDropdownId = null;
    },
    async deleteCard() {
      try {
        const res = await suggestionService.fetchDeleteSuggestion(this.cardDeleteDataId);
        if (res.Message == "Suggestion is deleted") {
          this.$toast.success("İşleminiz başarıyla tamamlandı.", {
            position: "top",
          });
          this.$store.dispatch("mindo/deleteSuggestionData");
          this.getSuggestionData();
        } else {
          this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
            position: "top",
          });
        }
      } catch (error) {
        this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
          position: "top",
        });
      }
    },
    async editSuggestion(item) {
      this.$store.dispatch("loading/setIsLoading", true);
      const tmpData = item;
      if (item.FileId != null) {
        const res = await upload.fetchDownloadFile(item.FileId);
        tmpData.DownloadFile = {
          DownloadBinary: res.Data.DownloadBinary,
          Extension: res.Data.Extension,
          Filename: res.Data.Filename,
          Id: res.Data.Id,
          fileType: fileTypeCheck(res.Data.Extension),
        };
      }
      this.editCardData = tmpData;
      this.isEditCard = true;
      this.cardDropdownId = null;
      this.$store.dispatch("loading/setIsLoading", false);
    },
  },
  created() {
    if (this.getSuggestions.length == 0 && this.questionId != null) {
      this.getSuggestionData();
    }
  },
  destroyed() {
    this.$store.dispatch("mindo/deleteSuggestionData");
  },
};
</script>